import React from 'react'
import { List as ListAnt } from 'antd'
import { ListProps } from 'antd/lib/list'

import { Empty } from '..'

function List<T>({ ...props }: ListProps<T>) {
  return (
    <ListAnt
      {...props}
      locale={{
        emptyText: <Empty />
      }}
    />
  )
}
const ListItem = ListAnt.Item
const ListItemMeta = ListAnt.Item.Meta

export default List
export { ListItem, ListItemMeta }
